import React from "react";
import styled from "@emotion/styled";

import {
  Typography as MuiTypography,
  Divider as MuiDivider,
} from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";

import { RootState } from "../../../redux/store";
import { Bookmark } from "../../../types/app";
import BookmarkGroupChip from "./BookmarkGroupChip";
import useAppSelector from "../../../hooks/useAppSelector";

const MainContainer = styled.div``;

const Divider = styled(MuiDivider)(spacing);

interface TypographyProps extends SpacingProps {
  component?: string;
}
const Typography = styled(MuiTypography)<TypographyProps>(spacing);

function BookmarkCardTitle({ bookmark }: { bookmark: Bookmark }) {
  const bookmarkState = useAppSelector((state: RootState) => state.bookmark);
  const color = bookmarkState.colorMapping[bookmark.group];

  return (
    <MainContainer>
      <BookmarkGroupChip label={bookmark.group} color={color} />
      <Typography gutterBottom variant="h5" component="h2">
        {bookmark.title}
      </Typography>
      <Typography gutterBottom component="h1">
        {bookmark.description}
      </Typography>
      <Divider my={3} />
    </MainContainer>
  );
}

export default BookmarkCardTitle;
